import { useLang } from '../contexts/LanguageContext';
import { Mail, MapPin } from 'lucide-react';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="bg-[#09090B] text-zinc-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <button
              onClick={() => scrollTo('#inicio')}
              className="mb-4 block focus:outline-none"
              data-testid="footer-logo"
            >
              <span
                className="font-bold text-xl text-white tracking-tight"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                RJ <span className="text-[#C2410C]">Montagens</span>
              </span>
            </button>
            <p className="text-sm leading-relaxed text-zinc-500 max-w-xs">
              {t('footer_tagline')}
            </p>
            <div className="flex items-center gap-2 mt-4 text-sm">
              <MapPin size={14} className="text-[#C2410C] flex-shrink-0" />
              <span className="text-zinc-500">Cascais, Amadora, Sintra, Oeiras, Odivelas, Loures e Lisboa</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4
              className="text-white font-bold text-sm mb-5"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              {t('footer_services_title')}
            </h4>
            <ul className="space-y-2.5">
              {(t('footer_services_list') || []).map((item, i) => (
                <li key={i}>
                  <button
                    onClick={() => scrollTo('#servicos')}
                    className="text-sm text-zinc-500 hover:text-white transition-colors"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-white font-bold text-sm mb-5"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              {t('footer_contact_title')}
            </h4>
            <div className="space-y-3">
              <a
                href="mailto:Rodrigo@ghafcarpintaria.pt"
                className="flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail size={14} className="text-[#C2410C]" />
                geral@rjmontagens.pt
              </a>
              <div className="flex items-start gap-2 text-sm text-zinc-500">
                <MapPin size={14} className="text-[#C2410C] mt-0.5 flex-shrink-0" />
                <span>Cascais, Amadora, Sintra, Oeiras, Odivelas, Loures e Lisboa</span>
              </div>
            </div>

            <button
              onClick={() => scrollTo('#contacto')}
              className="mt-6 px-5 py-2.5 bg-[#C2410C] hover:bg-[#9A3412] text-white text-sm font-semibold rounded-full transition-all duration-200 active:scale-95"
              data-testid="footer-cta"
            >
              {t('nav_cta')}
            </button>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © {year} RJ Montagens e Remodelações. {t('footer_rights')}
          </p>
          <a
            href="/admin"
            className="text-xs text-zinc-700 hover:text-zinc-500 transition-colors"
            data-testid="footer-admin-link"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
